import ko from 'i18n/locales/ko.json'
import en from 'i18n/locales/en.json'
import ja from 'i18n/locales/ja.json'
import es from 'i18n/locales/es.json'
import ro from 'i18n/locales/ro.json'
import th from 'i18n/locales/th.json'
import zh from 'i18n/locales/zh.json'

export default {
  ko: {translation: ko},
  en: {translation: en},
  ja: {translation: ja},
  es: {translation: es},
  ro: {translation: ro},
  th: {translation: th},
  zh: {translation: zh},
} as const
